import type { Brand } from '../brand';

interface BrandCapabilities {
  checkout: {
    /** Inventory includes pre-owned vehicles, so newness and mileage are worth showing.
     *  Every Slate vehicle is new with no meaningful mileage, so both are noise there. */
    sellsPreOwnedVehicles: boolean;
    hasVehicleDetailPages: boolean;
    sellsAccessories: boolean;
    advertisesZeroDueAtOrder: boolean;
    offersMoneyBackGuarantee: boolean;
    inspectsVehicles: boolean;
  };
  cart: {
    offersDownPaymentRecirculation: boolean;
    shipsFromNewCarDealerships: boolean;
    /** Slate keeps the self-arranged finance view, but does not offer it from the
     *  payment-type view — the tile only appears once it is the selected option. */
    allowsSelfArrangedFinancing: boolean;
  };
  vehiclePages: {
    comparesVehicles: boolean;
  };
  navigation: {
    offersSupportContact: boolean;
    /** Editing a placed order releases the scheduled appointment slot and puts the
     *  vehicle back on the market under a timer, so the warning has to say so. */
    releasesAppointmentOnEdit: boolean;
  };
}

const BRAND_CAPABILITIES: Record<Brand, BrandCapabilities> = {
  carvana: {
    checkout: {
      sellsPreOwnedVehicles: true,
      hasVehicleDetailPages: true,
      sellsAccessories: false,
      advertisesZeroDueAtOrder: true,
      offersMoneyBackGuarantee: true,
      inspectsVehicles: true
    },
    cart: {
      offersDownPaymentRecirculation: true,
      shipsFromNewCarDealerships: true,
      allowsSelfArrangedFinancing: true
    },
    vehiclePages: {
      comparesVehicles: true
    },
    navigation: {
      offersSupportContact: true,
      releasesAppointmentOnEdit: true
    }
  },
  slate: {
    checkout: {
      sellsPreOwnedVehicles: false,
      hasVehicleDetailPages: false,
      sellsAccessories: true,
      advertisesZeroDueAtOrder: false,
      offersMoneyBackGuarantee: false,
      inspectsVehicles: false
    },
    cart: {
      offersDownPaymentRecirculation: false,
      shipsFromNewCarDealerships: false,
      allowsSelfArrangedFinancing: false
    },
    vehiclePages: {
      comparesVehicles: false
    },
    navigation: {
      offersSupportContact: false,
      releasesAppointmentOnEdit: false
    }
  }
};

export { BRAND_CAPABILITIES };
export type { BrandCapabilities };
